module.exports = __webpack_public_path__ + "assets/17fe9eda25fccc154a8f58811288c6ba.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/freespin/anticipate/L585MLA_SpinMelodyR3.mp3
 ** module id = 239
 ** module chunks = 0
 **/